import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " D/M toa xe ", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Bạn có chắc chắn muốn xóa dữ liệu này?",
      width: "20%",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.deletingToaXe.ten_toa_xe), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "Chưa có toa xe nào được tạo",
      "max-height": "800",
      size: "small",
      "cell-style": {padding: '0', height: '15px'},
      border: true,
      data: _ctx.items
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Tên" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_toa_xe), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Mã toa xe" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_toa_xe), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Số hiệu" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.so_hieu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Chủng loại" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.chung_loai_toa_xe?.ky_hieu ? scope.row.chung_loai_toa_xe.ky_hieu : '-'), 1)
          ]),
          _: 1
        }),
        (_ctx.showDmToaXe)
          ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
              header: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx((scope) => [
                (scope.row.danh_muc_toa_xe.length)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      style: {"word-break":"break-word !important"},
                      to: {
            name: 'chi-tiet-danh-muc-toa-xe',
            params: {
              id: scope.row.danh_muc_toa_xe[0].id
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.danh_muc_toa_xe[0].ten_danh_muc), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_3, "-"))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { label: "Ghi chú" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ghi_chu ? scope.row.ghi_chu : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.INFO,
                "color-type": _ctx.ButtonTypeColors.INFO,
                onClick: ($event: any) => (_ctx.push(`/quan-ly/toa-xe/${scope.row.id}/chi-tiet`))
              }, null, 8, ["button-type", "color-type", "onClick"]),
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.EDIT,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                onClick: ($event: any) => (_ctx.push(`/quan-ly/toa-xe/${scope.row.id}/chinh-sua`))
              }, null, 8, ["button-type", "color-type", "onClick"]),
              _createVNode(_component_ButtonCustom, {
                hidden: "",
                "color-type": _ctx.ButtonTypeColors.DANGER,
                "button-type": _ctx.ButtonsType.TRASH,
                onClick: ($event: any) => (_ctx.onDeleteButtonClicked(scope.row.id))
              }, null, 8, ["color-type", "button-type", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}